<template>
  <a-table :columns="columns" :customRow="customRow" :data-source="touristList" :pagination="false" @change="handleChangeInTable">
    <template slot="soltName" slot-scope="text, record">
      <div class="flex-center">
        <div>{{ text }}</div>
        <!-- 昨天沟通需要向客户确认的点亮意向客户问题已经得到客户回复：点亮意向只有维护人才可以操作，点亮后在列表显示，维护人和A店长都可以看到 -->
        <div v-if="judgePermission(record) || record.accendantId === uidObj.userId" class="iconItem">
          <span v-if="record.identityWill === 'Y'">意</span>
        </div>
        <div v-if="record.identityFive === 'Y'" class="iconItem">五</div>
        <div v-if="record.identityExcellent === 'Y'" class="iconItem">优</div>
      </div>
    </template>
    <template slot="dishType" slot-scope="text, record">
      <div v-for="d in dishTypeOpts" :key="d.dictValue">
        <div
          v-if="record.dishType && d.dictValue == record.dishType"
          :class="{
            type1: d.dictLabel == '私盘',
            type2: d.dictLabel == '单店',
            type3: d.dictLabel == '公司'
          }"
          class="type li-item"
        >
          {{ d.dictLabel }}
        </div>
      </div>
    </template>

    <template slot="action" slot-scope="text, record">
      <div>
        <a-button type="link" @click="toDetail(record)">详情</a-button>
      </div>
    </template>
  </a-table>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: () => [],
      require: true
    },
    dishTypeOpts: {
      type: Array,
      default: () => [],
      require: true
    },
    nameTouristComponent: {
      type: String,
      default: ''
    },
    // 第一期修改 公客不显示维护人
    activeKey: {
      type: String,
      default: ''
    },
    activeNum: {
      type: [String, Number],
      default: ''
    }
  },
  watch: {
    dataList: {
      handler(val) {
        // console.log('rent dataList==', val)
        this.touristList = val;
      },
      deep: true,
      immediate: true
    },
    nameTouristComponent: {
      handler(val) {
        console.log(this.activeKey, '选中的tab');
        if (val === 'TouristList') {
          this.columns = [
            {
              title: '客源名称',
              dataIndex: 'lesseeName',
              key: 'lesseeName',
              width: 200,
              scopedSlots: { customRender: 'soltName' }
            },
            {
              title: '行业',
              dataIndex: 'industryCategoryName',
              key: 'industryCategoryName'
            },
            {
              title: '业态细分',
              dataIndex: 'industrySubclassName',
              key: 'industrySubclassName'
            },
            {
              title: '使用面积', // 第一期修改 使用面积范围 改为使用面积 面积值改为整数 新增修改的输入值也为整数
              key: 'requirementAreaStart',
              dataIndex: 'requirementAreaStart',
              customRender(text, record, index) {
                if (record.requirementAreaStart && record.requirementAreaEnd) {
                  return parseInt(record.requirementAreaStart || 0) + '-' + parseInt(record.requirementAreaEnd || 0) + 'm²';
                }
                return '无';
              }
            },
            {
              title: '租金范围（元/月）', // 第一期修改 租金范围去掉每行显示的“元/月”单位，将”租金范围”改为“租金范围（元/月）”
              key: 'rentExpenseStart',
              dataIndex: 'rentExpenseStart',
              customRender(text, record, index) {
                return (record.rentExpenseStart || 0) + '-' + (record.rentExpenseEnd || 0);
              }
              // scopedSlots: { customRender: 'tags' },
            },
            {
              title: '跟进时间', // 第一期修改 “跟进时间”将“跟进时间”每行数据后的“跟进”二字去掉（）
              key: 'followUpCreateTime',
              dataIndex: 'followUpCreateTime',
              sorter: true,
              customRender: (text, record, index) => {
                if (record.followUpCreateTime) {
                  return this.$moment(record.followUpCreateTime).format('YY-MM-DD HH:mm');
                } else {
                  return '无';
                }
              }
            },
            {
              title: '带看次数',
              sorter: true,
              key: 'takeLookCount',
              dataIndex: 'takeLookCount',
              customRender: (text, record, index) => {
                return (record.takeLookCount || 0) + '带' + record.inMoreCount + '多';
              }
            },
            {
              title: '维护人',
              key: 'relatedPersonnelName',
              dataIndex: 'relatedPersonnelName',
              customRender: (text, record, index) => {
                return record.dishType === ('3' || '2') ? '' : (record.teamName || '*') + '-' + record.relatedPersonnelName;
              }
            },
            {
              title: '录入时间',
              key: 'relatedPersonnelCreateTime',
              sorter: true,
              dataIndex: 'relatedPersonnelCreateTime',
              customRender: (text, record, index) => {
                return this.$moment(record.relatedPersonnelCreateTime).format('YY-MM-DD HH:mm') + ' 录入';
              }
            },
            {
              title: '类型',
              key: 'dishType',
              dataIndex: 'dishType',
              scopedSlots: { customRender: 'dishType' }
            }
          ];
        } else {
          this.columns = [
            {
              title: '客源名称',
              dataIndex: 'lesseeName',
              key: 'lesseeName',
              width: 200,
              scopedSlots: { customRender: 'soltName' }
            },
            {
              title: '品牌',
              dataIndex: 'brandName',
              key: 'brandName',
              width: 100,
              customRender(text, record, index) {
                if (record.brandName) {
                  return record.brandName;
                }
                return '无';
              }
            },
            {
              title: '地址信息',
              dataIndex: 'businessDistrictName',
              key: 'businessDistrictName',
              customRender(text, record, index) {
                if (record.businessDistrictName) {
                  return record.businessDistrictName + record.streetName;
                }
                return '无';
              }
            },
            {
              title: '使用面积范围',
              key: 'requirementAreaStart',
              dataIndex: 'requirementAreaStart',
              customRender(text, record, index) {
                if (record.requirementAreaStart && record.requirementAreaEnd) {
                  return (record.requirementAreaStart || 0) + '-' + (record.requirementAreaEnd || 0) + 'm²';
                }
                return '无';
              }
            },
            {
              title: '租金范围',
              key: 'rentExpenseStart',
              dataIndex: 'rentExpenseStart',
              customRender(text, record, index) {
                return (record.rentExpenseStart || 0) + '-' + (record.rentExpenseEnd || 0) + '元/月';
              }
              // scopedSlots: { customRender: 'tags' },
            },
            {
              title: '跟进时间',
              key: 'followUpCreateTime',
              sorter: true,
              dataIndex: 'followUpCreateTime',
              customRender: (text, record, index) => {
                if (record.followUpCreateTime) {
                  return this.$moment(record.followUpCreateTime).format('YY-MM-DD HH:mm') + ' 跟进';
                } else {
                  return '无';
                }
              }
            },
            {
              title: '带看次数',
              key: 'takeLookCount',
              sorter: true,
              dataIndex: 'takeLookCount',
              customRender: (text, record, index) => {
                return (record.takeLookCount || 0) + '带' + record.inMoreCount + '多';
              }
            },
            {
              title: '维护人',
              key: 'relatedPersonnelName',
              dataIndex: 'relatedPersonnelName',
              customRender: (text, record, index) => {
                return record.dishType === ('3' || '2') ? '' : (record.teamName || '*') + '-' + record.relatedPersonnelName;
              }
            },
            {
              title: '录入时间',
              key: 'relatedPersonnelCreateTime',
              sorter: true,
              dataIndex: 'relatedPersonnelCreateTime',
              customRender: (text, record, index) => {
                return this.$moment(record.relatedPersonnelCreateTime).format('YY-MM-DD HH:mm') + ' 录入';
              }
            },
            {
              title: '类型',
              key: 'dishType',
              dataIndex: 'dishType',
              scopedSlots: { customRender: 'dishType' }
            }
            // {
            //   title: '操作',
            //   key: 'action',
            //   dataIndex: 'action',
            //   scopedSlots: { customRender: 'action' },
            // },
          ];
        }
        console.log(val, '获取客源列表状态');
      },
      immediate: true
    },
    activeKey: {
      handler(val) {
        if (this.nameTouristComponent === 'TouristList') {
          // 第一期修改 公客的时候不显示维护人
          if (this.activeKey === '4' || this.activeKey === '5') {
            this.columns = [
              {
                title: '客源名称',
                dataIndex: 'lesseeName',
                key: 'lesseeName',
                width: 200,
                scopedSlots: { customRender: 'soltName' }
              },
              {
                title: '行业',
                dataIndex: 'industryCategoryName',
                key: 'industryCategoryName'
              },
              {
                title: '业态细分',
                dataIndex: 'industrySubclassName',
                key: 'industrySubclassName'
              },
              {
                title: '使用面积', // 第一期修改 使用面积范围 改为使用面积 面积值改为整数 新增修改的输入值也为整数
                key: 'requirementAreaStart',
                dataIndex: 'requirementAreaStart',
                customRender(text, record, index) {
                  if (record.requirementAreaStart && record.requirementAreaEnd) {
                    return parseInt(record.requirementAreaStart || 0) + '-' + parseInt(record.requirementAreaEnd || 0) + 'm²';
                  }
                  return '无';
                }
              },
              {
                title: '租金范围（元/月）', // 第一期修改 租金范围去掉每行显示的“元/月”单位，将”租金范围”改为“租金范围（元/月）”
                key: 'rentExpenseStart',
                dataIndex: 'rentExpenseStart',
                customRender(text, record, index) {
                  return (record.rentExpenseStart || 0) + '-' + (record.rentExpenseEnd || 0);
                }
                // scopedSlots: { customRender: 'tags' },
              },
              {
                title: '跟进时间', // 第一期修改 “跟进时间”将“跟进时间”每行数据后的“跟进”二字去掉（）
                key: 'followUpCreateTime',
                sorter: true,
                dataIndex: 'followUpCreateTime',
                customRender: (text, record, index) => {
                  if (record.followUpCreateTime) {
                    return this.$moment(record.followUpCreateTime).format('YY-MM-DD HH:mm');
                  } else {
                    return '无';
                  }
                }
              },
              {
                title: '带看次数',
                key: 'takeLookCount',
                sorter: true,
                dataIndex: 'takeLookCount',
                customRender: (text, record, index) => {
                  return (record.takeLookCount || 0) + '带' + record.inMoreCount + '多';
                }
              },
              {
                title: '录入时间',
                key: 'relatedPersonnelCreateTime',
                sorter: true,
                dataIndex: 'relatedPersonnelCreateTime',
                customRender: (text, record, index) => {
                  return this.$moment(record.relatedPersonnelCreateTime).format('YY-MM-DD HH:mm') + ' 录入';
                }
              },
              {
                title: '类型',
                key: 'dishType',
                dataIndex: 'dishType',
                scopedSlots: { customRender: 'dishType' }
              }
            ];
          } else {
            this.columns = [
              {
                title: '客源名称',
                dataIndex: 'lesseeName',
                key: 'lesseeName',
                width: 200,
                scopedSlots: { customRender: 'soltName' }
              },
              {
                title: '行业',
                dataIndex: 'industryCategoryName',
                key: 'industryCategoryName'
              },
              {
                title: '业态细分',
                dataIndex: 'industrySubclassName',
                key: 'industrySubclassName'
              },
              {
                title: '使用面积', // 第一期修改 使用面积范围 改为使用面积 面积值改为整数 新增修改的输入值也为整数
                key: 'requirementAreaStart',
                dataIndex: 'requirementAreaStart',
                customRender(text, record, index) {
                  if (record.requirementAreaStart && record.requirementAreaEnd) {
                    return parseInt(record.requirementAreaStart || 0) + '-' + parseInt(record.requirementAreaEnd || 0) + 'm²';
                  }
                  return '无';
                }
              },
              {
                title: '租金范围（元/月）', // 第一期修改 租金范围去掉每行显示的“元/月”单位，将”租金范围”改为“租金范围（元/月）”
                key: 'rentExpenseStart',
                dataIndex: 'rentExpenseStart',
                customRender(text, record, index) {
                  return (record.rentExpenseStart || 0) + '-' + (record.rentExpenseEnd || 0);
                }
                // scopedSlots: { customRender: 'tags' },
              },
              {
                title: '跟进时间', // 第一期修改 “跟进时间”将“跟进时间”每行数据后的“跟进”二字去掉（）
                key: 'followUpCreateTime',
                sorter: true,
                dataIndex: 'followUpCreateTime',
                customRender: (text, record, index) => {
                  if (record.followUpCreateTime) {
                    return this.$moment(record.followUpCreateTime).format('YY-MM-DD HH:mm');
                  } else {
                    return '无';
                  }
                }
              },
              {
                title: '带看次数',
                key: 'takeLookCount',
                sorter: true,
                dataIndex: 'takeLookCount',
                customRender: (text, record, index) => {
                  return (record.takeLookCount || 0) + '带' + record.inMoreCount + '多';
                }
              },
              {
                title: '维护人',
                key: 'relatedPersonnelName',
                dataIndex: 'relatedPersonnelName',
                customRender: (text, record, index) => {
                  return record.dishType === ('3' || '2') ? '' : (record.teamName || '*') + '-' + record.relatedPersonnelName;
                }
              },
              {
                title: '录入时间',
                key: 'relatedPersonnelCreateTime',
                sorter: true,
                dataIndex: 'relatedPersonnelCreateTime',
                customRender: (text, record, index) => {
                  return this.$moment(record.relatedPersonnelCreateTime).format('YY-MM-DD HH:mm') + ' 录入';
                }
              },
              {
                title: '类型',
                key: 'dishType',
                dataIndex: 'dishType',
                scopedSlots: { customRender: 'dishType' }
              }
            ];
          }
        }
      },
      immediate: true
    },
    // 监听
    activeNum: {
      handler(val) {},
      immediate: true
    }
  },
  computed: {
    // 拥有超级权限 ，
    getAdmin() {
      const arr = ['ZJL'];
      const loginRole = this.$getters.userInfo.data.roles;
      let status = false;
      loginRole.forEach((el) => {
        if (arr.includes(el)) {
          status = true;
        }
      });
      return status;
    }
  },
  data() {
    const columns = [];
    return {
      touristList: [],
      columns,
      uidObj: this.$getters.userInfo,
      AManager: false, // A店长的权限
      sortType: 'ASC',
      customRow: (record) => {
        return {
          on: {
            // 事件
            click: (event) => {
              // console.log(record,'record')
              this.toDetail(record);
            } // 点击行
          }
        };
      }
    };
  },
  methods: {
    judgePermission(itemInfo) {
      const info = (this.$store.state.user.info && this.$store.state.user.info.data.leaders) || [];
      const jurisdiction = info.map((item) => item.deptId).includes(itemInfo.accendantStoreId);

      return jurisdiction || this.getAdmin || false;
    },
    toDetail(record) {
      this.$emit('toDetail', record.id, record);
    },
    // 排序
    handleChangeInTable(pagination, filters, sorter) {
      if (sorter) {
        // sorter.columnKey  relatedPersonnelCreateTime 录入时间
        // sorter.columnKey  takeLookCount 带看次数
        // sorter.columnKey  followUpCreateTime  跟进时间
        // sorter.order   "descend" 降序   "ascend" 升序
        if (sorter.order === 'ascend') {
          this.sortType = 'ASC';
        } else {
          this.sortType = 'DESC';
        }
        this.requirementSort = sorter.columnKey
          ? sorter.columnKey === 'relatedPersonnelCreateTime'
            ? 1
            : sorter.columnKey === 'takeLookCount'
            ? 2
            : sorter.columnKey === 'followUpCreateTime'
            ? 3
            : 1
          : 1;
        this.$emit('GoSorter', this.requirementSort, this.sortType);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.type {
  //   margin-top: 40px;
  color: white;
  width: 50px;
  height: 30px;
  line-height: 30px;
  border-radius: 16px;
  text-align: center;
}

.flex-center {
  display: flex;
  align-items: center;
}

.iconItem {
  color: #1890ff;
  margin-left: 5px;
}

.type1 {
  background-color: #389e0d;
}

.type2 {
  background-color: #d48806;
}

.type3 {
  background-color: #cf1322;
}

/deep/ .ant-table-tbody > tr > td {
  padding: 8px 16px !important;
}
</style>
